import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { nextBirthdayFormatDate, toDateTime } from '@shared/utils/date-time';
import type { DateTime } from 'luxon';

@Pipe({ name: 'appBirthdayDate' })
export class AppBirthdayDatePipe implements PipeTransform {
    transform(value: string | DateTime | Date, withOrdinalHTML: boolean = false): any {
        const instance = toDateTime(value);

        if (instance?.isValid) {
            return nextBirthdayFormatDate(instance, true, withOrdinalHTML);
        }

        return value;
    }
}
